import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import { GENERAL_CONSTANTS } from "@/shared/constants/GeneralConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import store from "@/store";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { DASHBOARD_TEMPLATE_EVENTS } from "../../constants/DashboardTemplatesConstants";
import { FilterOfCollection } from "../../models/FilterOfCollection";
import {
  EventChart,
  SectionOfDashboard
} from "../../models/SectionOfDashboard";
import DashboardFilterGroup from "../DashboardFilterGroup/DashboardFilterGroup.vue";
import { Utils } from "@/shared/utils/utils";

@Component({
  name: "FiltersModal",
  components: { DashboardFilterGroup },
  computed: {
    ...mapGetters({
      sectionsOfDashboardStore: "getSectionsOfdashboard",
      eventChart: "getEventChart"
    })
  }
})
export default class FiltersModal extends Vue {
  @Prop() indexSection!: number;
  @Prop() refreshGoBack!: number;
  @Prop() indexCollection!: number;
  @Prop() waitingEventGraph!: boolean;
  @Prop() modalData!: {
    title: string;
  };

  groupByLocal: DynamicSelectData[] = [];
  seeByLocal: DynamicSelectData[] = [];

  eventChart!: EventChart;
  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  addItem = GENERAL_CONSTANTS.ICONS.ADD;
  filters: FilterOfCollection[] = [];
  sectionsOfDashboardStore!: Array<SectionOfDashboard>;
  collectionData: any = [];
  collectionFields: any = {};
  reloadFilter = 0;
  keyGroup = `${this.collectionFields?.id}`;

  mounted() {
    this.loadData();
  }

  convertToDynamicSelectData(
    items: string[] | DynamicSelectData[] | string | DynamicSelectData
  ): DynamicSelectData[] {
    if (!items) return [];
    if (Array.isArray(items)) {
      if (typeof items[0] === "string") {
        return (items as string[]).map((item: string) => ({
          id: item,
          name: item
        }));
      }
      return items as DynamicSelectData[];
    }

    if (typeof items == "string") {
      return [{ id: items, name: items } as DynamicSelectData];
    }

    return [items];
  }

  @Watch("refreshGoBack")
  loadData() {
    if (this.indexSection === -1) {
      return;
    }
    const collections = this.sectionsOfDashboardStore[this.indexSection]
      .collections[this.indexCollection];
    if (!collections) {
      return;
    }

    this.filters = collections.filters;
    this.collectionData = collections;
    this.collectionFields = this.collectionData.collection.find(
      (e: any) => e.id == this.collectionData.id
    );
    this.groupByLocal = this.convertToDynamicSelectData(collections.groupBy);
    this.seeByLocal = this.convertToDynamicSelectData(collections.seeBy);
    this.keyGroup = Utils.idGenerator();
  }

  addFilter() {
    store.commit(DASHBOARD_TEMPLATE_EVENTS.ADD_FILTER, {
      indexSectionOfDashboard: this.indexSection,
      index: this.indexCollection,
      onefilter: { field: [], operator: [], value: [] }
    });
    this.reloadFilter++;
  }

  emitSave(isSave: boolean) {
    this.$emit(
      DASHBOARD_TEMPLATE_EVENTS.SAVE_FILTER,
      this.indexSection,
      this.indexCollection,
      isSave
    );
  }

  saveFilter() {
    this.emitSave(true);
  }

  cancelFilter() {
    this.$emit(DASHBOARD_TEMPLATE_EVENTS.CANCEL_FILTER);
  }

  async makeQuery() {
    this.emitSave(false);
  }

  get showCard(): boolean {
    return this.collectionFields && !!this.collectionFields.id;
  }
}
